export const DEFAULT_BUSINESS_ID = 'Radical';
export const DEFAULT_COUNTRY = 'usa';
export const ITEM_TYPE_LABOR = 'labor';
export const ITEM_TYPE_CONTRACT = 'contractresearch';
export const ITEM_TYPE_SUPPLIES = 'supplies';
